var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row around-xs"},[_c('div',{staticClass:"col-xs-12 col-md-5"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }